import { render } from "./ProductGiftSelector.vue?vue&type=template&id=17662b3c&scoped=true&lang=pug"
import script from "./ProductGiftSelector.vue?vue&type=script&lang=js"
export * from "./ProductGiftSelector.vue?vue&type=script&lang=js"

import "./ProductGiftSelector.vue?vue&type=style&index=0&id=17662b3c&lang=sass&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17662b3c"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import qInstall from "../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip,QChip});
